import styles from "../DashBoard/HeaderTabs.module.css"
import { useNavigate } from "react-router-dom";
const HeaderTabs = ({ position, id, type, Tabs }) => {
  const navigate = useNavigate();

  return (
    <div className={styles.tabs}>
      {Tabs.map((i, index) => {
        if (position == index) {
          return (
            <div className={styles.navItemSelected} key={index}>
              <div className={styles.text}>
                <img className={styles.profileCardOutlineIcon} alt="" src={i.img} />
                <div className={styles.trash}><button className={styles.btn2} >{i.name}</button></div>
              </div>
            </div>
          )
        }

        else {
          return (
            <div className={styles.navItem} key={index}>
              <div className={styles.text} >
                <img className={styles.profileCardOutlineIcon} alt="" src={i.img1} />
                <div className={styles.trash}><button className={styles.btn1} onClick={() => navigate(i.link)}>{i.name}</button></div>
              </div>
            </div>
          )

        }
      })}
    </div>
  )
}
export default HeaderTabs;